// combatpro/encounter/entitlementApi.js
//
// Combat PRO - server-authoritative entitlement read (correction #1). Fetches the
// account's prepared-encounter caps from the existing /v1/combat-commerce/account
// endpoint (the same authoritative backend the pricing/membership pages read),
// reusing the shared authenticated API instance. This is a READ ONLY: the SERVER
// enforces the caps on save; the client uses these values for quota display and a
// pre-check so normal use never trips the server backstop. No optional chaining.
// No nullish coalescing. No em dash.

import API from '../../api';

export var COMBAT_ACCOUNT_PATH = '/v1/combat-commerce/account';

// Safe default = the most restrictive (lifetime base) tier, so the UI never
// over-promises capacity before the real entitlement resolves.
export function defaultEntitlement() {
  return { owned: true, cloud: false, tier: null, perFamily: 2, total: 2 };
}

export async function loadCombatEntitlement() {
  try {
    var res = await API.get(COMBAT_ACCOUNT_PATH);
    var d = res ? res.data : null;
    if (!d) { return null; }
    var caps = d.prepared_encounter_caps || null;
    var cloud = d.combat_cloud || null;
    return {
      owned: !!d.combat_pro_owned,
      cloud: !!cloud,
      tier: (cloud && cloud.tier) ? cloud.tier : null,
      perFamily: (caps && typeof caps.per_family === 'number') ? caps.per_family : 2,
      total: (caps && typeof caps.total === 'number') ? caps.total : 2
    };
  } catch (err) {
    return null;
  }
}
